import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";

export default function searchInventoryItems(
  items: InventoryItem[],
  query: string,
): InventoryItem[] {
  const result: InventoryItem[] = [];
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) return items;

  function recursiveSearch(items: InventoryItem[]) {
    for (const item of items) {
      const name = item.itemTemplate?.name?.toLowerCase() || "";
      const type = item.itemTemplate?.type?.toLowerCase() || "";
      const category = item.itemTemplate?.category?.toLowerCase() || "";
      const id = item.id.toLowerCase();
      const itemId = item.itemId.toString();
      const serialNumber = item.details?.weapon
        ? item.details?.weapon.serialNumber.toLowerCase()
        : "";

      // Проверяем, есть ли совпадение по какому-либо полю
      if (
        name.includes(normalizedQuery) ||
        type.includes(normalizedQuery) ||
        category.includes(normalizedQuery) ||
        id.includes(normalizedQuery) ||
        itemId.includes(normalizedQuery) ||
        (serialNumber && serialNumber.includes(normalizedQuery))
      ) {
        result.push(item);
      }

      // Рекурсия во вложенный инвентарь
      if (item.inventory?.items && item.inventory.items.length > 0) {
        recursiveSearch(item.inventory.items);
      }

      // Рекурсия в прикреплённые предметы
      if (item.attachedItems && item.attachedItems.length > 0) {
        recursiveSearch(item.attachedItems);
      }
    }
  }

  recursiveSearch(items);
  return result;
}
